
<list-item
  class="index-list-item"
  :card="index"
  :custom-fields="index.dailyIndex ? [{
    label: 'Index Value',
    value: $filters.number(index.dailyIndex),
  }] : null"
  v-bind="$attrs"
  v-on="$listeners"
>
  <template #image>
    <index-image :index="index" />
  </template>

  <template #info>
    <align class="index-list-item-info" flex>
      <div class="label">{{ index.label }}</div>
    </align>
  </template>
</list-item>
